import { HStack, Icon, Skeleton, Text } from '@chakra-ui/react';
import { Workshop } from 'api/types';
import { useTranslation } from 'react-i18next';
import { IoIosWarning } from 'react-icons/io';

import { Warning } from '../../components/Warning';

const WorkshopWarning = (props: { workshop: Workshop | undefined; isLoading: boolean }) => {
  const { t } = useTranslation();
  const { isLoading, workshop } = props;

  if (isLoading) {
    return (
      <Warning>
        <Skeleton h="20px" w="full" speed={2} fadeDuration={8} />
      </Warning>
    );
  }
  if (workshop?.is_verified) {
    return null;
  }
  return (
    <Warning>
      <HStack justifyContent={'start'}>
        <Icon as={IoIosWarning} color={'orange'} boxSize="7" />
        <Text as={'span'} fontWeight={'bold'}>
          {workshop?.name} {t('workshop_verification_request:not_verified')}
        </Text>
      </HStack>
    </Warning>
  );
};

export default WorkshopWarning;
